import 'styled-components/macro';
import React from 'react';
import { Typography, useTheme } from '@harver/shared-ui';

import { ContentCard } from '../../../components/ContentCard';
import CookieBanner from '../../../components/CookieBanner';

export function OpenInvite() {
    const theme = useTheme();
    return (
        <>
            <ContentCard
                note={
                    <span>
                        If you have any questions please reach out to the recruitment team. Their details can be found
                        in your email confirmation or invitation.
                    </span>
                }
            >
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        testId="openInvite.submit.confirmation"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        Your interview invite was success
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                        }}
                        variant="body2"
                    >
                        We have sent a confirmation of the interview invite to your email.
                    </Typography>
                </div>
                <CookieBanner />
            </ContentCard>
        </>
    );
}
